// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import { getUserPermissions, updateUserPermissions } from "../../../utils/api";

// interface UserReportProps {
//   username?: string;
//   employeeId?: string;
//   email: string;
//   userId?: string;
//   profilePicture?: string;
//   role?: string;
//   onClose?: () => void;
// }

// interface PermissionState {
//   resource: "orders" | "repairs" | "stock";
//   actions: string[];
// }

// const UserReport: React.FC<UserReportProps> = ({
//   username,
//   employeeId,
//   email,
//   userId,
//   profilePicture,
//   role,
//   onClose,
// }) => {
//   const [loading, setLoading] = useState(true);
//   const [allPermissions, setAllPermissions] = useState<PermissionState[]>([
//     { resource: "orders", actions: [] },
//     { resource: "repairs", actions: [] },
//     { resource: "stock", actions: [] },
//   ]);

//   // ✅ Fetch user permissions on modal open
//   useEffect(() => {
//     if (!userId) return;

//     const fetchPermissions = async () => {
//       try {
//         const data = await getUserPermissions(userId);

//         // ✅ Ensure all 3 resources are present
//         const resources = ["orders", "repairs", "stock"];
//         const normalized = resources.map((res) => {
//           const found = data.find((p: { resource: string; actions: string[] }) => p.resource === res);
//           return found || { resource: res as "orders" | "repairs" | "stock", actions: [] };
//         });

//         setAllPermissions(normalized);
//       } catch {
//         toast.error("Failed to load user permissions ❌");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPermissions();
//   }, [userId]);

//   // ✅ Toggle permission - only affects specific resource
//   const togglePermission = (resource: "orders" | "repairs" | "stock", action: string) => {
//     setAllPermissions((prev) =>
//       prev.map((perm) =>
//         perm.resource === resource
//           ? {
//               ...perm,
//               actions: perm.actions.includes(action)
//                 ? perm.actions.filter((a) => a !== action)
//                 : [...perm.actions, action],
//             }
//           : perm
//       )
//     );
//   };

//   // ✅ Save ALL permissions in one call
//   const handleSave = async () => {
//     try {
//       if (!userId) {
//         toast.error("User ID not found");
//         return;
//       }

//       // ✅ Send all permissions as array
//       await updateUserPermissions({
//         userId,
//         permissions: allPermissions,
//       });

//       toast.success("All permissions updated successfully ✅");
//     } catch (err: unknown) {
//       const errMsg = err instanceof Error ? err.message : "Permission update failed";
//       console.error("Update error:", err);
//       toast.error(errMsg || "Permission update failed ❌");
//     }
//   };

//   if (loading) return <div className="p-4 text-center">Loading permissions...</div>;

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-lg relative w-[450px] max-h-[600px] overflow-y-auto">
//       <button onClick={onClose} className="absolute top-2 right-2 text-xl hover:text-gray-600">
//         ✕
//       </button>

//       {/* User Info */}
//       <div className="flex flex-col items-center">
//         <img
//           src={profilePicture || "/images/profile.png"}
//           className="w-20 h-20 rounded-full border"
//           alt="Profile"
//         />
//         <h2 className="text-xl font-bold mt-2">{username || "N/A"}</h2>
//         <p className="text-gray-700">{email}</p>
//         <p className="text-sm text-gray-600">{employeeId || "N/A"}</p>
//         <p className="text-blue-600 font-semibold">{role || "N/A"}</p>
//       </div>

//       {/* Stats */}
//       <div className="w-full grid grid-cols-2 gap-4 mt-4">
//         <div className="bg-blue-50 rounded-lg p-4 text-center">
//           <div className="text-lg font-bold text-blue-700">45</div>
//           <div className="text-xs text-gray-500">Total PO Generated</div>
//         </div>
//         <div className="bg-green-50 rounded-lg p-4 text-center">
//           <div className="text-lg font-bold text-green-700">33</div>
//           <div className="text-xs text-gray-500">Completed PO</div>
//         </div>
//         <div className="bg-yellow-50 rounded-lg p-4 text-center">
//           <div className="text-lg font-bold text-yellow-700">12</div>
//           <div className="text-xs text-gray-500">Pending PO</div>
//         </div>
//         <div className="bg-red-50 rounded-lg p-4 text-center">
//           <div className="text-lg font-bold text-red-700">2</div>
//           <div className="text-xs text-gray-500">Delayed PO</div>
//         </div>
//       </div>

//       {/* Permissions */}
//       <h3 className="mt-6 font-bold text-lg">All Permissions:</h3>

//       {/* ✅ Loop through normalized permissions array */}
//       {allPermissions.map((perm) => (
//         <div
//           key={perm.resource}
//           className="border p-3 mt-3 rounded bg-gray-50"
//         >
//           <h4 className="font-semibold uppercase text-blue-700 mb-2">
//             {perm.resource}
//           </h4>

//           {/* ✅ Each action checkbox is independent */}
//           <div className="flex flex-col gap-2">
//             {["readOnly", "create", "update", "delete"].map((action) => (
//               <label key={action} className="flex items-center gap-2 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={perm.actions.includes(action)}
//                   onChange={() => togglePermission(perm.resource, action)}
//                   className="w-4 h-4"
//                 />
//                 <span className="text-sm capitalize">{action}</span>
//               </label>
//             ))}
//           </div>
//         </div>
//       ))}

//       {/* Save Button */}
//       <button
//         onClick={handleSave}
//         className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded mt-5 w-full font-semibold transition"
//       >
//         Update Permissions
//       </button>
//     </div>
//   );
// };

// export default UserReport;

import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getUserPermissions, updateUserPermissions } from "../../../utils/api";
import { FiX, FiUser, FiMail, FiBriefcase, FiCheckCircle, FiClock, FiAlertCircle, FiXCircle } from 'react-icons/fi';

interface UserReportProps {
  username?: string;
  employeeId?: string;
  email: string;
  userId?: string;
  profilePicture?: string;
  role?: string;
  onClose?: () => void;
}

interface PermissionState {
  resource: "orders" | "repairs" | "stock";
  actions: string[];
}

const UserReport: React.FC<UserReportProps> = ({
  username,
  employeeId,
  email,
  userId,
  profilePicture,
  role,
  onClose,
}) => {
  const [loading, setLoading] = useState(true);
  const [allPermissions, setAllPermissions] = useState<PermissionState[]>([
    { resource: "orders", actions: [] },
    { resource: "repairs", actions: [] },
    { resource: "stock", actions: [] },
  ]);
  const [activePermissionTab, setActivePermissionTab] = useState<"orders" | "repairs" | "stock">("orders");

  // ✅ Fetch user permissions on modal open
  useEffect(() => {
    if (!userId) return;

    const fetchPermissions = async () => {
      try {
        const data = await getUserPermissions(userId);

        // ✅ Ensure all 3 resources are present
        const resources = ["orders", "repairs", "stock"];
        const normalized = resources.map((res) => {
          const found = data.find((p: { resource: string; actions: string[] }) => p.resource === res);
          return found || { resource: res as "orders" | "repairs" | "stock", actions: [] };
        });

        setAllPermissions(normalized);
      } catch {
        toast.error("Failed to load user permissions");
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [userId]);

  // ✅ Toggle permission - only affects specific resource
  const togglePermission = (resource: "orders" | "repairs" | "stock", action: string) => {
    setAllPermissions((prev) =>
      prev.map((perm) =>
        perm.resource === resource
          ? {
              ...perm,
              actions: perm.actions.includes(action)
                ? perm.actions.filter((a) => a !== action)
                : [...perm.actions, action],
            }
          : perm
      )
    );
  };

  // ✅ Save ALL permissions in one call
  const handleSave = async () => {
    try {
      if (!userId) {
        toast.error("User ID not found");
        return;
      }

      await updateUserPermissions({
        userId,
        permissions: allPermissions,
      });

      toast.success("All permissions updated successfully");
      onClose?.();
    } catch (err: unknown) {
      const errMsg = err instanceof Error ? err.message : "Permission update failed";
      console.error("Update error:", err);
      toast.error(errMsg || "Permission update failed");
    }
  };

  const getInitials = (name: string) => {
    return name?.charAt(0).toUpperCase() || 'U';
  };

  const resourceIcons = {
    orders: "📦",
    repairs: "🔧",
    stock: "📊"
  };

  if (loading) {
    return (
      <div className="bg-white dark:bg-zinc-800 p-8 rounded-lg shadow-xl max-w-2xl w-full">
        <div className="text-center text-gray-700 dark:text-gray-300">Loading permissions...</div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-zinc-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden border border-gray-200 dark:border-zinc-700">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0A2975] to-blue-700 p-6 relative">
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-full p-2 transition-colors"
        >
          <FiX className="text-xl" />
        </button>

        <div className="flex items-center gap-4">
          {profilePicture ? (
            <img
              src={profilePicture}
              className="w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover"
              alt="Profile"
            />
          ) : (
            <div className="w-20 h-20 rounded-full border-4 border-white shadow-lg bg-blue-300 flex items-center justify-center text-white font-bold text-2xl">
              {getInitials(username || '')}
            </div>
          )}
          
          <div className="text-white flex-1">
            <h2 className="text-2xl font-bold">{username || "N/A"}</h2>
            <div className="flex items-center gap-2 text-blue-100 text-sm mt-1">
              <FiMail className="text-sm" />
              <span>{email}</span>
            </div>
            <div className="flex items-center gap-4 mt-2 text-sm">
              <span className="bg-white/20 px-3 py-1 rounded-full flex items-center gap-1">
                <FiUser />
                {employeeId || "N/A"}
              </span>
              <span className="bg-white/20 px-3 py-1 rounded-full flex items-center gap-1">
                <FiBriefcase />
                {role || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
        {/* Stats */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">Performance Overview</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
              <div className="flex items-center justify-between mb-1">
                <span className="text-2xl font-bold text-blue-700 dark:text-blue-400">45</span>
                <FiBriefcase className="text-blue-600 dark:text-blue-400" />
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400 font-medium">Total POs</div>
            </div>

            <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4 border border-green-200 dark:border-green-800">
              <div className="flex items-center justify-between mb-1">
                <span className="text-2xl font-bold text-green-700 dark:text-green-400">33</span>
                <FiCheckCircle className="text-green-600 dark:text-green-400" />
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400 font-medium">Completed</div>
            </div>

            <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
              <div className="flex items-center justify-between mb-1">
                <span className="text-2xl font-bold text-yellow-700 dark:text-yellow-400">12</span>
                <FiClock className="text-yellow-600 dark:text-yellow-400" />
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400 font-medium">Pending</div>
            </div>

            <div className="bg-red-50 dark:bg-red-900/20 rounded-lg p-4 border border-red-200 dark:border-red-800">
              <div className="flex items-center justify-between mb-1">
                <span className="text-2xl font-bold text-red-700 dark:text-red-400">2</span>
                <FiAlertCircle className="text-red-600 dark:text-red-400" />
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400 font-medium">Delayed</div>
            </div>
          </div>
        </div>

        {/* Permissions Section */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">Resource Permissions</h3>
          
          {/* Tabbed Permission Section */}
          <div className="bg-gray-50 dark:bg-zinc-900 rounded-lg border border-gray-200 dark:border-zinc-700 overflow-hidden">
            {/* Tabs */}
            <div className="grid grid-cols-3 bg-white dark:bg-zinc-800 border-b border-gray-200 dark:border-zinc-700">
              {allPermissions.map((perm) => (
                <button
                  key={perm.resource}
                  onClick={() => setActivePermissionTab(perm.resource)}
                  className={`flex flex-col items-center gap-1 py-3 px-2 transition-all ${
                    activePermissionTab === perm.resource
                      ? 'bg-[#0A2975] text-white'
                      : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-zinc-700'
                  }`}
                >
                  <span className="text-2xl">{resourceIcons[perm.resource]}</span>
                  <span className="text-xs font-semibold uppercase">
                    {perm.resource}
                  </span>
                </button>
              ))}
            </div>

            {/* Permission Content */}
            <div className="p-4">
              {allPermissions
                .filter(perm => perm.resource === activePermissionTab)
                .map((perm) => (
                  <div key={perm.resource} className="space-y-2">
                    {["readOnly", "create", "update", "delete"].map((action) => (
                      <div
                        key={action}
                        onClick={() => togglePermission(perm.resource, action)}
                        className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-all ${
                          perm.actions.includes(action)
                            ? action === 'delete'
                              ? 'bg-red-50 dark:bg-red-900/20 border-2 border-red-300 dark:border-red-700'
                              : 'bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700'
                            : 'bg-white dark:bg-zinc-800 border-2 border-gray-200 dark:border-zinc-700 hover:border-gray-300 dark:hover:border-zinc-600'
                        }`}
                      >
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <input
                              type="checkbox"
                              checked={perm.actions.includes(action)}
                              onChange={() => {}}
                              className={`w-5 h-5 rounded border-2 cursor-pointer appearance-none transition-all pointer-events-none
                                ${perm.actions.includes(action)
                                  ? action === 'delete'
                                    ? 'bg-red-500 border-red-500'
                                    : 'bg-[#0A2975] border-[#0A2975]'
                                  : 'border-gray-300 dark:border-zinc-600'
                                }
                              `}
                            />
                            {perm.actions.includes(action) && (
                              <svg
                                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 text-white pointer-events-none"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                              </svg>
                            )}
                          </div>
                          <span className={`text-sm font-medium capitalize ${
                            perm.actions.includes(action)
                              ? action === 'delete'
                                ? 'text-red-700 dark:text-red-300'
                                : 'text-blue-700 dark:text-blue-300'
                              : 'text-gray-700 dark:text-gray-300'
                          }`}>
                            {action === 'readOnly' ? 'Read Only' : action}
                          </span>
                        </div>
                        {action === 'delete' && (
                          <span className="text-xs font-bold text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30 px-2 py-1 rounded">
                            HIGH RISK
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="border-t border-gray-200 dark:border-zinc-700 p-4 bg-gray-50 dark:bg-zinc-900">
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 bg-gray-200 dark:bg-zinc-700 hover:bg-gray-300 dark:hover:bg-zinc-600 text-gray-800 dark:text-white font-semibold py-2.5 rounded-lg transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 bg-[#0A2975] hover:bg-blue-800 text-white font-semibold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <FiCheckCircle />
            Update Permissions
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserReport;